import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { PartyGameSplashScreenComponent } from './party-game-splash-screen.component';
import { PartyGameSplashScreenOverlayService } from './party-game-splash-screen-overlay.service';

@Component({
    selector: 'app-party-game-splash-screen-overlay',
    standalone: true,
    imports: [CommonModule, PartyGameSplashScreenComponent],
    templateUrl: './party-game-splash-screen-overlay.component.html',
    host: {
        class: 'contents',
    },
})
export class PartyGameSplashScreenOverlayComponent {
    public partyGameSplashScreenOverlayService: PartyGameSplashScreenOverlayService = inject(
        PartyGameSplashScreenOverlayService
    );
}
